import React from "react";
import MultiSearchTable from "./MultiSearchTable/index";
import { getUserPreference } from "../../../utilities/common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TextField, Button, Grid, MenuItem, makeStyles, Divider } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { useToken, useAlert } from "../../../utilities/hooks";
import moment from 'moment';
import _ from "lodash";
import { getBranchList } from '../../../actions/commonAction';

import {
    batchCloseIncident,
    searchMultipleTypeOrder
} from "../../../actions/incidentManagementActions";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    tnoTextfield: {
        marginTop: theme.spacing(-5),
        marginLeft: theme.spacing(4),
        width: '100%',
        alignItems: 'left',       // Vertically center-align items
    },
    leftdiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '20vh',
        width: '15%',
        backgroundColor: "primary",
    },
    rightdiv: {
        marginLeft: theme.spacing(-9),
        height: '20vh',
        width: '15%',
        backgroundColor: "#3C3C3C"
    },
    typeTextField: {
        width: '90%',
        margin: theme.spacing(2),
        flexDirection: 'row',
        alignItems: 'center',       // Vertically center-align items
    },
    grid: {
        // display: 'flex',
        alignItems: 'center',       // Vertically center-align items
        justifyContent: 'space-between', // Distribute items evenly
        flexDirection: 'row',
        margin: theme.spacing(2),   // Adjusted margin for all sides
    },
    firstGrid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    actionArea: {
        background: theme.palette.background.paper
    },
    borderLeftOrTop: {
        borderColor: theme.palette.divider,
        borderStyle: 'solid',
        [theme.breakpoints.up('lg')]: {
            borderWidth: '0 0 0 1px',
        },
        [theme.breakpoints.down('md')]: {
            borderWidth: '1px 0 0 0',
        }
    },
    headerItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',       // Vertically center-align items
        gap: theme.spacing(3),     // Space between items
        flexWrap: 'wrap',
        padding: theme.spacing(2)   // Adjusted padding
    },
    textField: {
        width: '100%',
    },
    Button: {
        marginTop: theme.spacing(2), // 调整上方间距
        display: 'flex',
        alignItems: 'right',
        marginRight: theme.spacing(-7),
    },
    searchButton: {
        backgroundColor: 'gray',
        color: 'white',
        '&:hover': {
            backgroundColor: 'darkgray',
        },
    },
    Button: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(5),   // Adjusted margin
    },
    refreshButton: {
        backgroundColor: 'gray',
        color: 'white',
        '&:hover': {
            backgroundColor: 'darkgray',
        },
    },
    icon: {
        width: '21.9px',
        height: '21.9px',
    },
    doubleRow: {
        gridRow: "span 2",  // 这里使Grid项跨越两行
    },
    actionArea: {
        background: theme.palette.background.paper
    },
}));

function IncidentMultiSearch() {
    const { t } = useTranslation('incidentManagement');

    const typeIndex = [
        // { label: "Create New Incidents", value: 1 },
        // { label: "In Progress", value: 2 },
        { label: "Update Refund Consignee Status", value: 3 },
        { label: "Update Refund Client Status", value: 4 },
        // { label: "Close Incidents", value: 5 }
    ];

    const lastStatusUpdate = [
        {
            id: 1,
            text: t('all'),
            value: 0
        },
        {
            id: 2,
            text: t('within_one_day'),
            value: 1
        },
        {
            id: 3,
            text: t('within_two_day'),
            value: 2
        },
        {
            id: 4,
            text: t('within_three_day'),
            value: 3
        },
        {
            id: 5,
            text: t('morethan_seven_day'),
            value: 7
        }
    ];

    const driverChargeStatus = [
        {
            id: 1,
            text: t('all'),
            value: 0
        },
        {
            id: 2,
            text: t('deduction'),
            value: 1
        },
        {
            id: 3,
            text: t('subsidy'),
            value: 2
        }
    ];

    const compensationStatusList = [
        {
            id: 1,
            text: t('all'),
            value: 0
        },
        {
            id: 2,
            text: t('consignee_refund'),
            value: 1
        },
        {
            id: 3,
            text: t('client_refund'),
            value: 2
        }
    ];

    const trackingStatusList = [
        {
            id: 1,
            text: t('all'),
            value: 0
        },
        {
            id: 2,
            text: t('SCANNED_PARCEL_MISSING'),
            value: 218
        },
        {
            id: 3,
            text: t('PARCEL_LOST'),
            value: 207
        }
    ];
    const branchList = useSelector(state => state.common.branches);
    const userList = useSelector(state => state.common.users);
    const statusList = useSelector(state => state.incidentManagement.statusList);
    const [orderstatistics, setOrderstatistics] = useState(null);
    const [trackingStatus, setTrackingStatus] = useState(null);
    const [compensationStatus, setCompensationStatus] = useState(null);
    const [chargeStatus, setChargeStatus] = useState(null);
    const [tnos, setTons] = useState('');
    const [day, setDay] = useState(null);
    const [dateRange, setDateRange] = useState({
        from: moment().startOf('day'),
        to: moment().endOf('day')
    });
    const dispatch = useDispatch();
    const classes = useStyles();
    const userPref = getUserPreference();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const tokenContents = useToken();
    const [warehouses, setWarehouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState([]);
    const alertDialog = useAlert();
    const [detailedDate, setDetailedDate] = useState([]);
    const [timezone, setTimezone] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);

    const handleSelectedRows = (selectedRowsFromChild) => {
        setSelectedRows(selectedRowsFromChild);
    };
    useEffect(() => {
        dispatch(getBranchList()).then((warehouses) => {
            setWarehouses(warehouses);
        });
    }, []);

    const handleBatchClose = async () => {
        let params = {
            review_type: selectedType ? parseInt(selectedType, 10) : 0,
            incident_ids: selectedRows,
        }
        try {
            let responseData = await dispatch(batchCloseIncident(params));
            let successList = [];
            let failList = [];
            _.forEach(responseData, (value) => {
                if (value.success) {
                    successList.push(value.id)
                } else {
                    failList.push(value.id)
                }
            })

            alertDialog.addAlertDialog(
                t('dialog:incident_batch_close'),
                [
                    t('dialog:incident_batch_close_message'),
                    `Failed: ${failList.length > 0 ? failList.join(", ") : "None"}`,
                    `Success: ${successList.length > 0 ? successList.join(", ") : "None"}`
                ], null,
                t('common:ok'),
                () => {
                    handleSearch();
                    setSelectedRows([]);
                    alertDialog.hideAlert();
                }
            );
            alertDialog.showAlert();
        } catch (error) {
            alertDialog.addAlertDialog(
                t('dialog:incident_batch_close'),
                error.message
            );
            alertDialog.showAlert();
        }
    }

    const handleWarehouseChange = (event, newValue) => {
        setSelectedWarehouse(newValue);
    };

    const handleChargeStatusChange = (event) => {
        setChargeStatus(event.target.value);
    };

    const handleCompensationChange = (event) => {
        setCompensationStatus(event.target.value);
    };

    const handleTrackingStatusChange = (event) => {
        setTrackingStatus(event.target.value);
    };

    const handleDayChange = (event) => {
        setDay(event.target.value);
    };

    const handleTnosChange = (event) => {
        setTons(event.target.value);
    };

    const handleSearch = () => {
        setIsDataLoading(true);
        const params = {};

        if (!_.isNil(tnos) && tnos !== "") {
            params.tnos = tnos.split('\n')
                .map(tno => tno.trim())
                .filter(tno => tno !== "")
                .join(', ');
        }

        if (!_.isNil(day) && day !== "") {
            params.last_status_update = day;
        }

        if (!_.isNil(chargeStatus) && chargeStatus !== "") {
            params.driver_charge_status = chargeStatus;
        }

        if (!_.isNil(compensationStatus) && compensationStatus !== "") {
            params.compensation_status = compensationStatus;
        }

        if (!_.isNil(trackingStatus) && trackingStatus !== "") {
            params.latest_status = trackingStatus;
        }

        if (!_.isNil(selectedWarehouse)) {
            params.warehouse = selectedWarehouse.map(warehouse => warehouse.id);
        }

        dispatch(searchMultipleTypeOrder(params))
            .then((response) => {
                setDetailedDate(response.result);
                setOrderstatistics(response.statistics);
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('search_success'),
                    type: 'success'
                }));
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('search_failed'),
                    type: 'error'
                }));
                setDetailedDate([]);  // Clear the table data
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    };

    useEffect(() => {
        dispatch(getBranchList()).then((warehouses) => {
            setWarehouses(warehouses);
        });
    }, []);

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <div style={{ display: 'flex' }}>
                        <div className={classes.leftdiv}>
                            <TextField
                                fullWidth
                                className={classes.tnoTextfield}
                                id='helpdesk_changeorderwarehouse_textfield'
                                placeholder={t('tno_tips')}
                                onChange={handleTnosChange}
                                multiline
                                rows={5}
                                variant="outlined"
                            />
                        </div>

                        <div style={{ height: '20vh', width: '70%', backgroundColor: 'primary' }}>
                            <Grid container spacing={0}>
                                <Grid item xs={2} className={classes.grid}>
                                    <TextField
                                        id="last_status_updated"
                                        variant="outlined"
                                        label={t('last_status_updated')}
                                        value={day}
                                        onChange={handleDayChange}
                                        fullWidth
                                        className={classes.textField}
                                        select
                                    >
                                        {lastStatusUpdate.map((item) => (
                                            <MenuItem key={item.id} value={item.value}>
                                                {t(item.text)}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={4} className={classes.grid}>
                                    <Autocomplete
                                        multiple
                                        options={warehouses}
                                        getOptionLabel={(option) => option.name}
                                        value={selectedWarehouse}
                                        onChange={handleWarehouseChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label={t('warehouse')}
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={2} className={classes.grid}>
                                    <TextField
                                        id="driver_charge_status"
                                        variant="outlined"
                                        label={t('driver_charge_status')}
                                        value={chargeStatus}
                                        onChange={handleChargeStatusChange}
                                        fullWidth
                                        className={classes.textField}
                                        select
                                    >
                                        {driverChargeStatus.map((item) => (
                                            <MenuItem key={item.id} value={item.value}>
                                                {t(item.text)}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={2} className={classes.grid}>
                                    <TextField
                                        id="compensation_status"
                                        variant="outlined"
                                        label={t('compensation_status')}
                                        value={compensationStatus}
                                        onChange={handleCompensationChange}
                                        fullWidth
                                        className={classes.textField}
                                        select
                                    >
                                        {compensationStatusList.map((item) => (
                                            <MenuItem key={item.id} value={item.value}>
                                                {t(item.text)}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={2} className={classes.grid}>
                                    <TextField
                                        id="last_tracking_status"
                                        variant="outlined"
                                        label={t('last_tracking_status')}
                                        value={trackingStatus}
                                        onChange={handleTrackingStatusChange}
                                        fullWidth
                                        className={classes.textField}
                                        select
                                    >
                                        {trackingStatusList.map((item) => (
                                            <MenuItem key={item.id} value={item.value}>
                                                {t(item.text)}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={2} className={classes.grid}>
                                    <Button
                                        id='button-search'
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => handleSearch()}
                                    >
                                        {t('common:search')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>

                        <div className={classes.rightdiv}>
                            <TextField
                                select
                                fullWidth
                                variant="outlined"
                                className={classes.typeTextField}
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                                SelectProps={{
                                    native: true,
                                }}
                            >
                                <option value="Batch Operation">Batch Operation</option>
                                {typeIndex.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </TextField>
                            <Button
                                className={classes.typeTextField}
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleBatchClose}
                                style={{ marginTop: '10px' }}
                            >
                                {t('common:confirm')}
                            </Button>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Divider style={{ backgroundColor: 'gray', orientation: "vertical" }} />
                </Grid>
                <Grid item xs={12}>
                    <MultiSearchTable
                        orderstatistics={orderstatistics}
                        branchList={branchList}
                        statusList={statusList}
                        userList={userList}
                        data={detailedDate}
                        isDataLoading={isDataLoading}
                        timezone={timezone}
                        onSelectedRowsChange={handleSelectedRows}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default IncidentMultiSearch;
